<template>
  <v-card class="mb-5 mr-5" min-width="300" max-width="374"  @click="navigateVenue(location.id)">
  <v-card-text> 
         {{location.title}}
      <line-chart :values="returnCounts"></line-chart>

      </v-card-text>
      </v-card>
</template>

<script>

  import LineChart from '@/components/Charts/LineChart.vue';

export default {

    props:["location"],
     components: {
    LineChart
  },
  computed:{
      returnCounts(){
            var ar = [];
            for(var x=0; x<this.location.counts.length;x++){
                ar.push(this.location.counts[x].count);
            }
            if(ar.length==0){
              ar = [0,0,0,0,0,0,0];
            }
         
          
            return ar.reverse();
      }
  },
 methods: {
      navigateVenue(id){
        this.$router.push('venue/' + id);
      }
  },
}
</script>

<style>

</style>